module.exports = __webpack_public_path__ + "img/login-v2-dark.018a3761.svg";